"use client";
import React from "react";
import "./index.css";
import Image from "next/image";
import BlogChip from "../blog-chip/BlogChip";
import Link from "next/link";

const RecentBlog = ({ name, date, title, image, slug }) =>
(
  <Link
    className="resent-blog d-flex w-100 text-decoration-none"
    href={`/${slug}`}
  >
    <div className="image">
      <Image
        src={image}
        alt="resent-blog-image"
        className="rounded d-block"
        width={82}
        height={82}
      />
    </div>
    <div className="details">
      <BlogChip name={name} date={date} />
      <p className="title fw-medium text-capitalize">{title}</p>
    </div>
  </Link>
)

export default RecentBlog;
